import React, { useEffect, useState } from "react";
import { Card, CardContent, CardHeader, Divider } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { editInternalResource, getProfileNumber, getResourcePosition, getResourceStatusOptions, getTreeMenueOptions, UpdateSaveUserProfileInternal } from "../../../redux/Thunk/internalResourceThunk/internalResourceThunk";
import { SaveUserProfileInternal } from "../../../redux/Thunk/internalResourceThunk/internalResourceThunk";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useNavigate, useParams } from "react-router-dom";
import Btn from "../../../Components/Ui_elements/Btn";
import Form from "./Form";
import dayjs from "dayjs";
import Loader from "../../../Components/Ui_elements/Loader";
import { getUserDashboardTabs } from "../../../redux/Thunk/DashboardModule/DashboardThunk";
import APP_CONFIG_URL_ENV from "../../../env-config";
import { setloginUserData, setProfileImageGlobal } from "../../../redux/Slice/authSlice/loginSlice";
import { formatInternationalMobile, parseIMobile } from "../../../Helper/phone";

const AddUpdateResource = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.root.loading);
  const { user } = useSelector((state) => state.root.authUser);
  const { profile_number, resourceStatusList, resourcePosition, menuePermission, edit_internal_resource_data } = useSelector((state) => state.root.InternalResource);
  const { userDashboardTabs } = useSelector((state) => state.root.DashboardModule);
  const [profilePreview, setProfilePreview] = useState(null);
  const [absentPeriods, setAbsentPeriods] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const params = useParams();
  const ID = params?.id;
  const isSuperAdmin = edit_internal_resource_data?.data?.super_admin || (user?.vResourcePosition == 1) || (user?.iUserId == 1)
  useEffect(() => {
    const request = { id: user?.iUserId };
    const customPayload = {
      id: user?.iUserId,
      isglobal: 'is_global=1'
    }

    if (ID) {
      dispatch(editInternalResource(ID));
    }

    dispatch(getUserDashboardTabs(customPayload));
    dispatch(getProfileNumber(request));
    dispatch(getResourceStatusOptions());
    dispatch(getResourcePosition(request));
    dispatch(getTreeMenueOptions());

    return () => {
      // Cleanup function to prevent memory leaks
      setProfilePreview(null);
      setAbsentPeriods([]);
    };
  }, [dispatch, user?.iUserId, ID]);

  const initialState = {
    profileNumber: ID ? `${edit_internal_resource_data?.data?.iResourceNumber}` : `${profile_number}`,
    resourceStatus: "",
    firstName: "",
    lastName: "",
    gender: "",
    dateOfBirth: "",
    position: [],
    absentFrom: "",
    absentTo: "",
    username: "",
    password: "",
    email: "",
    mobile: {
      countryIso: "US",
      phoneCode: "1",
      number: "",
      nicename: "",
    },
    skype: "",
    tabsPermission: [],
    menuPermission: [],
    profilePicture: null,
  };
  const [formData, setFormData] = useState(initialState);
  const [isProfilePictureChanged, setIsProfilePictureChanged] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (!ID) {
      setFormData({
        ...initialState,
        profile_number: profile_number,
      });
    }
  }, [profile_number]);


  useEffect(() => {
    if (edit_internal_resource_data?.data && ID) {
      const {
        vFirstName,
        vLastName,
        eUserStatus,
        iGender,
        dtBirthDate,
        vResourcePosition,
        vEmailAddress,
        org_pass,
        vSkypeName,
        iMobile,
        tabPermission,
        permissionTabs,
        menu_access,
        is_available,
        vProfilePic,
        S3vProfilePic,
      } = edit_internal_resource_data?.data;

      const mobileParsed = parseIMobile(iMobile);

      let absentPeriodsData = [];
      try {
        absentPeriodsData = is_available && typeof is_available === "string" ? JSON.parse(is_available) : [];
        if (!Array.isArray(absentPeriodsData)) {
          absentPeriodsData = [];
        }
      } catch (e) {
        console.error("Error parsing absent periods:", e);
        absentPeriodsData = [];
      }

      // Parse tabPermission and map to tab_id using permissionTabs
      let tabsPermissionData = [];
      try {
        if (tabPermission) {
          if (typeof tabPermission === "string") {
            const parsedTabPermission = JSON.parse(tabPermission);
            if (Array.isArray(parsedTabPermission)) {
              tabsPermissionData = parsedTabPermission.map(String);
            } else if (typeof parsedTabPermission === "object") {
              const permissionKeys = Object.keys(parsedTabPermission).filter(
                (key) => parsedTabPermission[key]
              );
              tabsPermissionData = permissionKeys
                .map((key) => {
                  const matchedTab = permissionTabs?.find(
                    (tab) => tab.tab_permission_key === key
                  );
                  return matchedTab ? String(matchedTab.tab_id) : null;
                })
                .filter(Boolean);
            }
          } else if (Array.isArray(tabPermission)) {
            tabsPermissionData = tabPermission.map(String);
          }
        }
      } catch (e) {
        console.error("Error parsing tabPermission:", e);
        tabsPermissionData = [];
      }

      // Map menu permissions from lowercase to title-case labels
      let menuPermissionData = [];
      try {
        menuPermissionData = menu_access && typeof menu_access === "string"
          ? Object.keys(JSON.parse(menu_access))
          : [];

        // Map lowercase menu_access keys to menuePermission labels
        menuPermissionData = menuPermissionData
          .map((key) => {
            const matchedMenu = menuePermission.find(
              (menu) => menu.label.toLowerCase() === key.toLowerCase()
            );
            return matchedMenu ? matchedMenu.label : null;
          })
          .filter(Boolean);
      } catch (e) {
        console.error("Error parsing menu_access:", e);
        menuPermissionData = [];
      }

      const positionIds = vResourcePosition ? String(vResourcePosition).split(",") : [];

      const mappedPositions = positionIds
        .map((id) => {
          const matchedPosition = resourcePosition.find(
            (pos) => pos.value == id || pos.label == id
          );
          return matchedPosition ? matchedPosition.value : id;
        })
        .filter(Boolean);

      let profileImage = null;
      if (S3vProfilePic) {
        profileImage = S3vProfilePic
      }
      else {
        profileImage = vProfilePic.startsWith("data:image")
          ? vProfilePic
          : vProfilePic.startsWith("http")
            ? vProfilePic
            : `${APP_CONFIG_URL_ENV.REACT_APP_FILEPATH}profilePic/${vProfilePic}`;
      }

      setFormData({
        profileNumber: `${edit_internal_resource_data?.data?.iResourceNumber}`,
        resourceStatus: eUserStatus,
        firstName: vFirstName,
        lastName: vLastName,
        gender: iGender == "1" ? "Male" : iGender == "2" ? "Female" : "Other",
        dateOfBirth: dtBirthDate,
        position: mappedPositions,
        absentFrom: "",
        absentTo: "",
        username: `${vFirstName} ${vLastName}`,
        password: org_pass,
        email: vEmailAddress,
        mobile: {
          countryIso: mobileParsed?.countryFlagClass?.split(" ")[1]?.toUpperCase() || "US",
          phoneCode: mobileParsed?.phoneCode || "1",
          number: mobileParsed?.nationalNumber || "",
          nicename: mobileParsed?.countryTitle || "",
        },
        skype: vSkypeName,
        tabsPermission: tabsPermissionData,
        menuPermission: menuPermissionData, // Use the mapped title-case labels
        profilePicture: profileImage,
      });

      setAbsentPeriods(
        absentPeriodsData.map((period) => ({
          from: period.dateFrom,
          to: period.dateTo,
          id: new Date().getTime(),
        }))
      );

      if (profileImage) {
        setProfilePreview(profileImage);
      }
    }
  }, [edit_internal_resource_data, ID, resourcePosition, menuePermission]);
  const validateForm = () => {
    const newErrors = {};
    if (!formData.position) {
      newErrors.position = "Position is required";
    }
    if (!formData.resourceStatus) {
      newErrors.resourceStatus = "Resource status is required";
    }
    if (!formData.firstName) {
      newErrors.firstName = "First Name is required";
    }
    if (!formData.lastName) {
      newErrors.lastName = "Last Name is required";
    }
    if (!formData.gender) {
      newErrors.gender = "Gender is required";
    }
    if (!formData.position || formData.position.length === 0) {
      newErrors.position = "Position is required";
    }
    if (!formData.username) {
      newErrors.username = "Username is required";
    }
    if (!formData.password) {
      newErrors.password = "Password is required";
    }
    if (!formData.email) {
      newErrors.email = "Email is required";
    }

    if (isSuperAdmin == 1) {
      if (!formData.tabsPermission || formData.tabsPermission.length === 0) {
        newErrors.tabsPermission = "Tabs Permission is required";
      }
      if (!formData.menuPermission || formData.menuPermission.length === 0) {
        newErrors.menuPermission = "Menu Permission is required";
      }
    }

    return newErrors;
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const base64String = e.target.result;
        setFormData((prevData) => ({
          ...prevData,
          profilePicture: base64String,
        }));
        setProfilePreview(base64String);
        setIsProfilePictureChanged(true);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevState) => {
      const updatedFormData = {
        ...prevState,
        [name]: value,
      };

      if (name === "firstName" || name === "lastName") {
        updatedFormData.username = `${updatedFormData.firstName} ${updatedFormData.lastName}`.trim();
      }

      return updatedFormData;
    });

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleMultiSelectChange = (e, field) => {
    const { value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [field]: value,
    }));
    setErrors(prevErrors => ({
      ...prevErrors,
      [field]: "",
    }));
  };

  const handleChipDelete = (value, field) => {
    const newValues = formData[field].filter(item => item !== value);
    setFormData(prevState => ({
      ...prevState,
      [field]: newValues,
    }));
  };

  const handleAddAbsentPeriod = () => {
    const { absentFrom, absentTo } = formData;

    if (absentFrom && absentTo) {
      const newFrom = new Date(absentFrom);
      const newTo = new Date(absentTo);

      // Check for overlap with existing periods
      const isOverlapping = absentPeriods.some(period => {
        const existingFrom = new Date(period.from);
        const existingTo = new Date(period.to);

        // Overlap exists if newFrom <= existingTo AND newTo >= existingFrom
        return newFrom <= existingTo && newTo >= existingFrom;
      });

      if (isOverlapping) {
        alert("This absent period overlaps with an existing one.");
        return;
      }

      const newAbsentPeriod = {
        from: absentFrom,
        to: absentTo,
        id: new Date().getTime(),
      };

      setAbsentPeriods(prev => [...prev, newAbsentPeriod]);

      setFormData(prevState => ({
        ...prevState,
        absentFrom: "",
        absentTo: "",
      }));
    }
  };


  const handleDeleteAbsentPeriod = (id) => {
    setAbsentPeriods((prev) => prev.filter((period) => period.id !== id));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const newErrors = validateForm();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setIsSubmitting(false);
      return;
    }

    // Base payload without image
    const payload = {
      created_by: user?.iUserId,
      dtBirthDate: formData.dateOfBirth || "",
      dtCreationDate: new Date().toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      }),
      eUserStatus: formData.resourceStatus,
      iGender: formData.gender === "Male" ? "1" : formData.gender === "Female" ? "2" : "3",
      iMobile: JSON.stringify({
        countryTitle: `${formData.mobile.nicename}`,
        countryFlagClass: `iti-flag ${formData.mobile.countryIso.toLowerCase()}`,
        mobileNumber: formatInternationalMobile({
          phoneCode: formData.mobile.phoneCode,
          number: formData.mobile.number,
        }),
      }),
      iResourceNumber: formData.profileNumber,
      is_available: JSON.stringify(
        absentPeriods.map(period => ({
          dateFrom: dayjs(period.from).format("YYYY-MM-DD"),
          dateTo: dayjs(period.to).format("YYYY-MM-DD"),
          multiDay: period.from === period.to ? 0 : 1,
        }))
      ),
      menu_access: JSON.stringify(
        formData.menuPermission.reduce((acc, permissionLabel) => {
          acc[permissionLabel.toLowerCase()] = true;
          return acc;
        }, {})
      ),
      tabPermission: `[${formData.tabsPermission.join(",")}]`,
      vEmailAddress: formData.email,
      vFirstName: formData.firstName,
      vLastName: formData.lastName,
      vPassword: formData.password,
      vResourcePosition: formData.position.join(","),
      vSkypeName: formData.skype,
      vUserName: `${formData.firstName} ${formData.lastName}`,
    };

    if (user?.iUserId == ID && formData.profilePicture && isProfilePictureChanged) {
      dispatch(setProfileImageGlobal(formData.profilePicture));

    }
    // Conditionally add image to payload only if it has changed
    if (formData.profilePicture && isProfilePictureChanged) {
      payload.image = formData.profilePicture;
    }

    try {
      if (ID) {
        const res = await dispatch(UpdateSaveUserProfileInternal({
          ...payload,
          iUserId: ID,
          activation_token: edit_internal_resource_data?.data[0]?.activation_token
        })).unwrap();

        // If user updated their own profile, refresh auth user immediately (redux + persisted).
        if (Number(ID) === Number(user?.iUserId) && res?.userData) {
          dispatch(setloginUserData({ user: res.userData, isAuthenticated: true }));
        }
        setIsProfilePictureChanged(false);
      } else {
        await dispatch(SaveUserProfileInternal(payload)).unwrap();
      }

      navigate('/resources/internal');
    } catch (error) {
      console.error("Operation failed:", error);
    } finally {
      setIsSubmitting(false);
      setIsProfilePictureChanged(false);
    }
  };
  const tabsPermissionOption = userDashboardTabs
    ?.filter(tab => tab.is_global !== 0)  // Only include tabs where is_global is not 0, custom tabs wont be seen
    ?.map(item => ({
      label: item.tab_name,
      value: item.id,
    }));

  const isLoggedInSuperAdmin = user?.super_admin == 1;
  const canResetDeactivatedPassword =
    isLoggedInSuperAdmin &&
    ID &&
    Number(ID) !== Number(user?.iUserId) &&
    formData.resourceStatus == 4;

  return (
    <Card>
      <CardHeader
        title={ID ? "Edit Internal Resource" : "Add Internal Resource"}
        action={
          <Btn
            variant="outlined"
            startIcon={<KeyboardBackspaceIcon />}
            onClick={() => window.history.back()}
          >
            Back
          </Btn>
        }
      />
      <Divider />
      {
        loading ? <Loader /> :
          <CardContent>
            <Form
              formData={formData}
              IdfromParams={ID}
              errors={errors}
              handleChange={handleChange}
              handleSubmit={handleSubmit}
              resourceStatusList={resourceStatusList}
              handleMultiSelectChange={handleMultiSelectChange}
              resourcePosition={resourcePosition}
              handleChipDelete={handleChipDelete}
              handleAddAbsentPeriod={handleAddAbsentPeriod}
              absentPeriods={absentPeriods}
              handleDeleteAbsentPeriod={handleDeleteAbsentPeriod}
              handleFileChange={handleFileChange}
              profilePreview={profilePreview}
              setProfilePreview={setProfilePreview}
              tabsPermissionOption={tabsPermissionOption}
              menuePermission={menuePermission}
              isSubmitting={isSubmitting}
              isSuperAdmin={isSuperAdmin}
              canResetDeactivatedPassword={canResetDeactivatedPassword}
            />
          </CardContent>
      }
    </Card>
  );
};

export default AddUpdateResource;